import { useAsync } from "../async";
import { patientService } from "../../../services/medicationmanagement/patientApi/PatientApi";
import { LinkButton } from "../link-button/LinkButton";
import { ReactComponent as PrintIcon } from "../../../images/print-icon.svg";

import {Button, CircularProgress, makeStyles} from "@material-ui/core";
import { UserType } from "../../../services/medicationmanagement/medsUser/MedsUserApi";
import { logger } from "../logger";
import { toast } from "../toast";

export function DownloadFile<T>(
  props: { 
    downloadPath:string;
    userType: UserType;
  }
) {
  let { inProgress, success, error, queryDispatcher } = useAsync();

  const useStyles = makeStyles({
    printIcon: { fill: "currentColor", marginRight: "2px" },
    print: { color: '#008381', fontWeight: 600}
  });

  const classes = useStyles();

  const downloadPrintPDF = async () => {
    queryDispatcher(
      patientService
        .getDownloadFile(props.downloadPath)
        .then((response) => {
            let url = window.URL.createObjectURL(response);
            let anchorElement = document.createElement("a");
            anchorElement.href = url;
            anchorElement.target = "_blank";
            anchorElement.click();
          })  
          .catch((err) => {
            logger.error(err);
            toast.showError("We have experienced an issue opening the print version of the chart. Please try again.");
          })  
  );
  };

  if (inProgress) {
    return (
      <CircularProgress
        style={{
          color: "var(--dna-alias-color-primary)",
          marginLeft: "0px",
          marginRight: "50px",
          verticalAlign:"middle"
        }}
        size={30}
      />
    );
  }

  return (
    <Button className={classes.print} variant={"outlined"}
      onClick={downloadPrintPDF}
      startIcon={<PrintIcon title="" className={classes.printIcon} />}
    >
    {props.userType == UserType.Pharmacist ? 'Print chart with all changes' :  'Print finalised chart'}  
    </Button>
  );
}
